var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "smartphone",
    xmlns: "http://www.w3.org/2000/svg",
    width: 67.472,
    height: 67.48,
    viewBox: "0 0 67.472 67.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M153.051,460a1.319,1.319,0,1,0,.933.386A1.329,1.329,0,0,0,153.051,460Zm0,0",
    transform: "translate(-131.736 -399.37)",
    fill: "#3c6142"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M62.2,36.724l-9.3-9.3a4.718,4.718,0,0,0-7.871,2.045,4.721,4.721,0,0,0-2.327-.524V5.536A5.542,5.542,0,0,0,37.167,0H5.536A5.541,5.541,0,0,0,0,5.536V27.809a1.318,1.318,0,1,0,2.635,0V11.071H40.067V29.846A4.688,4.688,0,0,0,38.14,33.74a4.71,4.71,0,0,0-4.555,3.19l-7.624-7.624a4.715,4.715,0,0,0-6.668,6.668L36.8,53.481l-3.091-.75a4.913,4.913,0,0,0-5.869,3.482c-.018.065-.032.131-.047.2H2.636V39.671a1.318,1.318,0,0,0-2.636,0V61.944A5.542,5.542,0,0,0,5.536,67.48H37.166a5.529,5.529,0,0,0,4.083-1.8l2.283.8A18.017,18.017,0,0,0,62.2,36.724ZM2.636,8.435v-2.9a2.9,2.9,0,0,1,2.9-2.9H37.166a2.9,2.9,0,0,1,2.9,2.9v2.9ZM37.166,64.844H5.536a2.9,2.9,0,0,1-2.9-2.9v-2.9h25.3a4.891,4.891,0,0,0,3.009,3.043l7.3,2.545A2.9,2.9,0,0,1,37.166,64.844ZM60.34,60.339A15.466,15.466,0,0,1,44.4,63.986L31.817,59.6a2.247,2.247,0,0,1,.748-4.369,2.219,2.219,0,0,1,.522.063l7.654,1.858a1.318,1.318,0,0,0,1.243-2.213L21.157,34.11a2.079,2.079,0,1,1,2.94-2.94L34.713,41.786h0l6.527,6.527A1.318,1.318,0,1,0,43.1,46.45l-6.527-6.528h0a2.079,2.079,0,0,1,2.941-2.94l6.866,6.867a1.318,1.318,0,1,0,1.864-1.864l-6.867-6.866a2.079,2.079,0,1,1,2.94-2.94l1.911,1.911,5.019,5.019a1.318,1.318,0,0,0,1.864-1.864L48.1,32.225a2.079,2.079,0,1,1,2.94-2.94l9.3,9.3A15.4,15.4,0,0,1,60.34,60.339Zm0,0",
    fill: "#3c6142"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M109.872,124.339a1.318,1.318,0,0,0,.932-2.25,13.829,13.829,0,0,0-19.534,0,1.318,1.318,0,0,0,1.864,1.864,11.189,11.189,0,0,1,15.806,0A1.314,1.314,0,0,0,109.872,124.339Zm0,0",
    transform: "translate(-78.906 -102.492)",
    fill: "#3c6142"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M124.32,167a1.318,1.318,0,0,0,1.864,1.864,5.021,5.021,0,0,1,7.094,0A1.318,1.318,0,0,0,135.142,167,7.662,7.662,0,0,0,124.32,167Zm0,0",
    transform: "translate(-107.599 -143.049)",
    fill: "#3c6142"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M1.322,248.636A1.318,1.318,0,1,0,0,247.318a1.319,1.319,0,0,0,1.318,1.318Zm0,0",
    transform: "translate(-0.003 -213.578)",
    fill: "#3c6142"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMobile);
export default __webpack_public_path__ + "static/media/icon-mobile.892fbd4e49ab6b639d52dd8596eee25a.svg";
export { ForwardRef as ReactComponent };